import { Component } from '@angular/core';
import { HeaderService } from '../app-header/app.header.service'
import { LocalUtils } from 'app/restricted/restricted.utils';

@Component({
  selector: 'app-sidebar-minimizer',
  templateUrl: './app-sidebar-minimizer.component.html'
})
export class AppSidebarMinimizerComponent { 

  isMinimized: boolean = false;
  colors = LocalUtils.colorsDefault;

  constructor(
    private headerService: HeaderService
  ) {
  }

  minimizer() {
    this.headerService.sidebarMinimized(!this.isMinimized);
    this.isMinimized = !this.isMinimized;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.ts